import {bellConstants, bellRemoteConstants, dashboardConstants, schoolDashboardConstants} from "../../constants/ApiConstant";
import Axios from "../../axios.js";
import {playEmergencyBellFromFrontend} from "../../utils/EmergencyBellPlayer";

export async function toggleBellSwitch(params) {
    return Axios.post(bellRemoteConstants.BELL_SWITCH, params);
}

export async function playEmergencyBell(params) {
    return playEmergencyBellFromFrontend(params?.emergencyType);
}

export async function fetchDashboardTiles() {
    return Axios.get(schoolDashboardConstants.FETCH_DASHBOARD_TILES);
}

// Marquee ticker config for the bell screen — returns the section colour,
// message text and scroll speed configured on the backend.
export async function fetchMarquee() {
    return Axios.get(bellConstants.BELL_MARQUEE);
}
